import { OfferService } from '@spilca/order_ts/v1/order_web/offer_web_pb_service';
import { getOfferConstructor } from '@monorepo/offers';

const getOffersList = (filter: object | undefined) =>
  getOfferConstructor(filter, OfferService.ListOffer);

export default getOffersList;
